import React, { createContext, useContext, useState } from "react";

const AppThemeContext = createContext();

export const AppThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("dark");
  const toggleTheme = () => setTheme(theme === "light" ? "dark" : "light");

  return (
    <AppThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </AppThemeContext.Provider>
  );
};

const useAppTheme = () => {
  const context = useContext(AppThemeContext);
  return { ...context };
};

export default useAppTheme;
